import cn from 'classnames';
import React__default from 'react';
import { useIsMobile } from '@sravni/react-utils';
import modules_cf168cce from './Preloader.module.scss.js';

const PreloaderPolygon = ({ style, className }) => (React__default.createElement("div", { className: cn(modules_cf168cce.figure, modules_cf168cce['figure--polygon'], className), style: style }));
const PreloaderCircle = ({ style, className }) => (React__default.createElement("div", { className: cn(modules_cf168cce.figure, modules_cf168cce['figure--circle'], className), style: style }));
const BlockListPreloader = ({ itemsCount, isPopup, isVerticalOnMobile, }) => {
    const isMobile = useIsMobile();
    return (React__default.createElement("div", { className: modules_cf168cce.wrapper },
        React__default.createElement("div", { className: cn(modules_cf168cce.content, {
                [modules_cf168cce['content--two-rows']]: itemsCount > 4 && !isPopup && !isMobile,
                // [styles['content--mobile-horizontal']]: isPopup && isMobile,
                [modules_cf168cce['content--mobile-horizontal']]: isMobile && !isVerticalOnMobile,
            }) }, Array(itemsCount)
            .fill(null)
            .map((_, i) => (React__default.createElement("div", { className: cn(modules_cf168cce.block, modules_cf168cce.preloader), key: `special-offers-preloader-block-${i}` },
            React__default.createElement("div", { className: modules_cf168cce.row },
                React__default.createElement("div", { style: { flex: '1 1 auto' } },
                    React__default.createElement(PreloaderPolygon, { style: { width: '70%', height: '20px' } }),
                    React__default.createElement(PreloaderPolygon, { style: { width: '40%' }, className: "h-mt-4" })),
                React__default.createElement(PreloaderCircle, { style: { width: '40px', height: '40px' } })),
            React__default.createElement(PreloaderPolygon, { style: { width: '15%', height: '20px' }, className: "h-mt-16" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '45%' }, className: "h-mt-16" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '90%', height: '20px' }, className: "h-mt-4" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '70%' }, className: "h-mt-16" })))))));
};

export { BlockListPreloader };
//# sourceMappingURL=Preloader.js.map
